'use client'

import { Session } from '@repo/sdk/auth'
import { SessionProvider } from 'next-auth/react'
import { PropsWithChildren } from 'react'

import { UpFetchProvider } from '../utils'
import { PostHogProvider } from './posthog.tsx'
import { TanstackProvider } from './tanstack-provider.tsx'

export const SdkProvider = ({
  accessToken,
  children,
  session = null,
}: PropsWithChildren<{
  accessToken?: string
  session?: null | Session
}>) => {
  return (
    <TanstackProvider>
      <PostHogProvider>
        <SessionProvider session={session}>
          <UpFetchProvider accessToken={session?.user?.access_token || accessToken}>
            {children}
          </UpFetchProvider>
        </SessionProvider>
      </PostHogProvider>
    </TanstackProvider>
  )
}
